import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the AudienceDetail state domain
 */

const selectAudienceDetailDomain = state => state.AudienceDetail || initialState;

/**
 * Other specific selectors
 */

const makeSelectFirstRender = () =>
  createSelector(
    selectAudienceDetailDomain,
    substate => substate.firstRender,
  );

const makeSelectInitialID = () =>
  createSelector(
    selectAudienceDetailDomain,
    substate => substate.initialID,
  );

// Load
const makeSelectAudienceDetail = () =>
  createSelector(
    selectAudienceDetailDomain,
    substate => substate.itemDetail,
  );
const makeSelectAudienceLoading = () =>
  createSelector(
    selectAudienceDetailDomain,
    substate => substate.loadDetail,
  );
const makeSelectAudienceError = () =>
  createSelector(
    selectAudienceDetailDomain,
    substate => substate.errorDetail,
  );

// New
const makeSelectAudienceIsNew = () =>
  createSelector(
    selectAudienceDetailDomain,
    substate => substate.isNew,
  );
const makeSelectAudienceIsNewSuccess = () =>
  createSelector(
    selectAudienceDetailDomain,
    substate => substate.isNewSuccessful,
  );

// Update
const makeSelectAudienceUpdateSuccess = () =>
  createSelector(
    selectAudienceDetailDomain,
    substate => substate.updateSuccessful,
  );
const makeSelectAudienceUpdateLoading = () =>
  createSelector(
    selectAudienceDetailDomain,
    substate => substate.loadingUpdate,
  );
const makeSelectAudienceUpdateError = () =>
  createSelector(
    selectAudienceDetailDomain,
    substate => substate.errorUpdate,
  );

// Delete
const makeSelectAudienceDeleteSuccess = () =>
  createSelector(
    selectAudienceDetailDomain,
    substate => substate.hardDeleteSuccessful,
  );
const makeSelectAudienceDeleteLoading = () =>
  createSelector(
    selectAudienceDetailDomain,
    substate => substate.hardDeleteLoading,
  );
const makeSelectAudienceDeleteError = () =>
  createSelector(
    selectAudienceDetailDomain,
    substate => substate.hardDeleteError,
  );

/**
 * Default selector used by Audiences
 */
const makeSelectAudiences = () =>
  createSelector(
    selectAudienceDetailDomain,
    substate => substate,
  );

export default makeSelectAudiences;
export {
  selectAudienceDetailDomain,
  // init
  makeSelectFirstRender,
  makeSelectInitialID,
  // load
  makeSelectAudienceDetail,
  makeSelectAudienceLoading,
  makeSelectAudienceError,
  // new
  makeSelectAudienceIsNew,
  makeSelectAudienceIsNewSuccess,
  // update
  makeSelectAudienceUpdateSuccess,
  makeSelectAudienceUpdateLoading,
  makeSelectAudienceUpdateError,
  // delete
  makeSelectAudienceDeleteSuccess,
  makeSelectAudienceDeleteLoading,
  makeSelectAudienceDeleteError,
};
